exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td{padding-top:12px;padding-bottom:12px;margin:0;border-bottom:1px solid #0b0c0c;font-family:\"nta\",Arial,sans-serif;font-weight:400;text-transform:none;font-size:14px;line-height:1.1428571429}@media(min-width: 641px){td{font-size:16px;line-height:1.25}}td:nth-child(1){width:20px}td:nth-child(2){width:70%}td:nth-child(3){text-align:right;width:10%}", ""]);

// exports
